module.exports = __webpack_public_path__ + "img/shape_semicircle_l.97a30e0e.svg";